import React from 'react';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { translate } from 'shared/utils/translation';

import './index.scss';

const NotFoundPage = () => {
  return (
    <div className="not-found">
      <h2 className="not-found__header">
        4
        <FontAwesomeIcon icon={faTimesCircle} size="xs" />
        4
        <i className="las la-phone-volume" />
      </h2>
      <div className="not-found__description">{translate('common.notFound.title')}</div>
    </div>
  );
};

export default NotFoundPage;
